import { useBrand } from "../context/BrandContext";
import BrandLogo from "./BrandLogo";
import "./StaffLoading.css";

export default function StaffLoading({ fullScreen = true }) {
  const { logos } = useBrand();
  return (
    <div className={`staff-loading${fullScreen ? " staff-loading-full" : ""}`} role="status" aria-live="polite">
      <div className="staff-loading-card">
        <div className="staff-loading-brand">
          <BrandLogo src={logos?.loading || logos?.app || logos?.login} />
        </div>
        <h1>Getting your workspace ready.</h1>
        <p>Loading your Alkeya staff workspace...</p>
        <div className="staff-loading-track" aria-hidden="true"><span /></div>
      </div>
    </div>
  );
}
